import { render, staticRenderFns } from "./main-profile-data.vue?vue&type=template&id=185c3858"
import script from "./main-profile-data.vue?vue&type=script&lang=js"
export * from "./main-profile-data.vue?vue&type=script&lang=js"
import style0 from "./main-profile-data.vue?vue&type=style&index=0&id=185c3858&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports